import { soundAlertsSlice } from "./reducer";

export const { selectSound, toggleEnabled, setDelay, setRepeat } =
  soundAlertsSlice.actions;
